module.exports = "<section class=\"app-footer\">\n    <div class=\"container-fluid\">\n        <span class=\"float-left\">\n            <span>Copyright © <a class=\"brand\" target=\"_blank\" [href]=\"AppConfig.productLink\">{{AppConfig.brand}}</a> {{AppConfig.year}}</span>\n        </span>\n\n    </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = 998
// module chunks = 7